import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";

// import JS files
import MuiTextField from "../../shares/MuiTextField";
import MuiButton from "../../shares/MuiButton";
import useFetch from "../../../context/useFetch";
import { fixNumbers } from "../../../utils";
import OrderCard from "../../shares/OrderCard";
import OrderCardLeftPart from "./OrderCardLeftPart";
import CreateOrderCard from "../../shares/CreateOrderCard";

// import Others files

const TabTwo = (props) => {
  const [ringCode, setRingCode] = useState(undefined);
  const [enterBtn, setEnterBtn] = useState(false);

  const [ringsList, setRingsList] = useState({ results: [] });
  const GetRingsApi = useFetch({
    method: "get",
    url: "Bangle_Service",
    params: {
      code: fixNumbers(ringCode),
    },

    trigger: false,
    setter: setRingsList,
    argFunc: (res) => {
      if (res.results.length <= 0) {
        toast.error("النگویی با کد موردنظر یافت نشد!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handleButton = () => {
    setEnterBtn(true);
    GetRingsApi.reFetch();
  };

  const empty_search = () => {
    setRingsList({ results: [] });
    setRingCode("");
  };

  return (
    <>
      {props.selectedUser !== undefined ? (
        <div className="mb-4">
          <span className="text-myblue-100">
            مشتری انتخاب شده:{" "}
            <span className="text-gray-700">{props.selectedUser?.name}</span>
          </span>
        </div>
      ) : (
        ""
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 items-center">
        <span className="mb-2 md:mb-0 text-sm md:text-base">
          کد النگو موردنظر خود را به صورت کامل جستجو کنید.
        </span>
        <div className="mb-2 md:mb-0">
          <MuiTextField
            isLTR={true}
            id="code"
            label="کد النگو"
            variant="outlined"
            size="small"
            onChange={(e) => setRingCode(e.target.value)}
            value={ringCode}
          />
        </div>
        <div className="text-left mt-2 md:mb-0">
          <MuiButton
            onClick={handleButton}
            variant="contained"
            icon={<SearchIcon />}
            color="primary"
            text="جستجو"
          />
        </div>
      </div>
      {ringsList.results.length > 0 && (
        <div className="mt-8 border rounded-md p-1">
          <CreateOrderCard ring={ringsList.results[0]}>
            <OrderCardLeftPart
              item={ringsList.results[0]}
              emptySearchData
              empty_search={empty_search}
            />
          </CreateOrderCard>
        </div>
      )}
    </>
  );
};

export default TabTwo;
